import {
  RootStoreMobX as CommonRootStoreMobX,
  ConfigRoot as ConfigRootCommon,
} from '@gimlite/common/stores/root.store';
import { RootStoreContext } from '../hooks/useStore.hook';
import { AppStoreMobX } from './app.store';
import { MenuStoreMobX } from './menu.store';
import { ThemeStoreMobX } from './theme.store';
import { WizardStoreMobX } from './wizard.store';

export class RootStoreMobX extends CommonRootStoreMobX {
  AppStore: AppStoreMobX;
  ThemeStore: ThemeStoreMobX;
  MenuStore: MenuStoreMobX;
  WizardStore: WizardStoreMobX;
  constructor() {
    super();
    this.AppStore = new AppStoreMobX(this);
    this.ThemeStore = new ThemeStoreMobX(this);
    this.MenuStore = new MenuStoreMobX(this);
    this.WizardStore = new WizardStoreMobX(this);
  }
}

export const RootStore: RootStoreMobX = new RootStoreMobX();

export const ConfigRoot = ({ children }: { children: React.ReactNode }) => {
  return (
    <ConfigRootCommon>
      <RootStoreContext.Provider value={RootStore ?? new RootStoreMobX()}>
        {children}
      </RootStoreContext.Provider>
    </ConfigRootCommon>
  );
};
